export default __webpack_public_path__ + "144c844b65e4554274e5ec69e5082bdf.png";